import { Pressable, View } from 'react-native';
import { cn } from '../../lib/utils';
import { Typography } from '../Typography/Typography';

type InputLikeButtonProps = {
  name: string;
  placeholder: string;
  text?: string;
  iconComponent?: React.ElementType;
  rounded?: 'full' | 'left' | 'right';
  children?: React.ReactNode;
  onPress?: () => void;
  hasError?: boolean;
  isFocused?: boolean;
  disabled?: boolean;
  className?: string;
};

export const InputLikeButton = ({
  name,
  placeholder,
  text,
  iconComponent: IconComponent,
  children,
  onPress,
  hasError,
  isFocused = false,
  className,
  disabled,
  rounded = 'full',
}: InputLikeButtonProps) => {
  const defaultStyles = 'border border-neutral-500 hover:border-primary';
  const errorStyles = 'border-2 border-error';

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      className={cn(
        'h-[56px] flex-row items-center bg-neutral-600 px-4',
        hasError ? errorStyles : defaultStyles,
        className,
        !disabled && 'active:opacity-20',
        rounded === 'full' && 'rounded-2xl',
        rounded === 'left' && 'rounded-l-2xl',
        rounded === 'right' && 'rounded-r-2xl',
        isFocused && 'border-2 border-primary',
      )}>
      {name && (
        <View
          className={cn(
            'absolute top-0 left-3 bg-neutral-600 rounded-b-sm h-2 overflow-visible',
            hasError || isFocused ? 'mt-[-2px]' : 'mt-[-1px]',
          )}>
          <Typography className="relative -mt-3 h-6">{name}</Typography>
        </View>
      )}
      {children ?? (
        <View className="flex-row items-center flex-1">
          <Typography
            size="large"
            className={cn(
              'mr-1 flex-1',
              text ? 'text-white' : 'text-neutral-300',
            )}>
            {text || placeholder}
          </Typography>
          {IconComponent && <IconComponent />}
        </View>
      )}
    </Pressable>
  );
};
